import React, { FC, PropsWithChildren } from 'react';
import { ToastContainer } from 'react-toastify';

import { ThemeProvider } from '@mui/material/styles';
import LocalStorage from '@src/LocalStorage';
import theme from '@src/theme';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import AuthorizationContext from '@contexts/common/AuthorizationContext';
import ModalsProvider from '@contexts/common/ModalContext';
import VaultFactoriesContext from '@contexts/vaults/VaultFactoriesContext';
import VaultTokensContext from '@contexts/vaults/VaultTokensContext';
import VaultsFiltersContext from '@contexts/vaults/VaultsFiltersContext';

import { Wagmi } from '@tools/wagmi';

import Layout from '@components/common/Layout';

import Modals from '@modules/modals';

import {
  TOAST_DEFAULT_AUTO_CLOSE_TIME,
  TOAST_DEFAULT_POSITION,
} from '@constants/common/toast.constants';

const queryClient = new QueryClient();

const Providers: FC<PropsWithChildren> = ({ children }) => (
  <VaultsFiltersContext>
    <ModalsProvider>
      <LocalStorage>
        <Wagmi>
          <QueryClientProvider client={queryClient}>
            {/* <ReactQueryDevtools initialIsOpen={false} /> */}
            <ThemeProvider theme={theme}>
              <AuthorizationContext>
                <VaultTokensContext>
                  <VaultFactoriesContext>
                    <Layout>{children}</Layout>
                    <Modals />
                    <ToastContainer
                      position={TOAST_DEFAULT_POSITION}
                      autoClose={TOAST_DEFAULT_AUTO_CLOSE_TIME}
                      hideProgressBar={false}
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      icon={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                    />
                  </VaultFactoriesContext>
                </VaultTokensContext>
              </AuthorizationContext>
            </ThemeProvider>
          </QueryClientProvider>
        </Wagmi>
      </LocalStorage>
    </ModalsProvider>
  </VaultsFiltersContext>
);

export default Providers;
